import { FC, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Heading, Link, Text } from '@livechat/design-system-react-components';

import { Product, ProductCard } from 'types/product';
import { Layout } from 'components/layout/Layout';
import Location from 'services/Location';
import { buildOauthQuery } from 'helpers/oath-query-builder';

import { LogoutProductCard } from './product-card/LogoutProductCard';

import * as styles from './styles';

const PRODUCTS_CARD_CONTENT: ProductCard[] = [
  {
    name: 'LiveChat',
    description: 'Connect with\ncustomers',
    product: Product.LiveChat,
    link: import.meta.env.VITE_APP_LC_LANDING,
  },
  {
    name: 'ChatBot',
    description: 'Automate customer\nservice with AI',
    product: Product.ChatBot,
    link: import.meta.env.VITE_APP_CB_LANDING,
  },
  {
    name: 'HelpDesk',
    description: 'Support customers\nwith tickets',
    product: Product.HelpDesk,
    link: import.meta.env.VITE_APP_HD_LANDING,
  },
  {
    name: 'KnowledgeBase',
    description: 'Improve support\nwith self-service',
    product: Product.KnowledgeBase,
    link: import.meta.env.VITE_APP_KB_LANDING,
  },
  {
    name: 'OpenWidget',
    description: 'Enhance websites\nwith widgets',
    product: Product.OpenWidget,
    link: import.meta.env.VITE_APP_OW_LANDING,
  },
  {
    name: 'Text Platform',
    description: 'Build and monetize\nautomation tools',
    product: Product.Platform,
    link: import.meta.env.VITE_APP_TP_LANDING,
  },
  {
    name: 'Partner Program',
    description: 'Perfect for solution providers',
    product: Product.PartnerProgram,
    link: import.meta.env.VITE_APP_PP_LANDING,
  },
  {
    name: 'Text Accounts',
    description: 'Manage your account and products',
    product: Product.Accounts,
    link: import.meta.env.VITE_APP_PANEL_URI,
  },
];

export const Logout: FC = () => {
  const getRedirectURL = (): string => {
    /* eslint-disable camelcase */
    const client_id = Location.getUrlParam('client_id');
    const redirect_uri = Location.getUrlParam('redirect_uri');
    const response_type = Location.getUrlParam('response_type');
    const code_challenge = Location.getUrlParam('code_challenge');
    const code_challenge_method = Location.getUrlParam('code_challenge_method');

    const params = {
      client_id,
      redirect_uri,
      response_type,
      code_challenge,
      code_challenge_method,
    };
    /* eslint-enable camelcase */

    return `/?${buildOauthQuery(params)}`;
  };

  useEffect(() => {
    Cookies.remove('access_token');
  }, []);

  return (
    <Layout>
      <div css={styles.logoutTitleContainerStyles}>
        <Heading size="xl" css={styles.logoutTitleStyles}>
          You have logged out successfully
        </Heading>
        <div>
          <Text css={styles.logBackStyles}>
            Want to get back?{' '}
            <Link href={getRedirectURL()} css={styles.logBackLinkStyles} bold={false}>
              Log in
            </Link>
          </Text>
        </div>
        <Heading size="md" css={styles.logoutMessageStyles}>
          Thanks for using our products, see you soon!
        </Heading>
        <div css={styles.cardsContainerStyles}>
          {PRODUCTS_CARD_CONTENT.map((product) => (
            <LogoutProductCard
              product={product.product}
              productName={product.name}
              description={product.description}
              imgUrl={product.imgUrl}
              link={product.link}
              key={product.name}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};
